import React, { useEffect, useState } from "react";
import BedFlightIcon from "../../../assets/images/icons/bedflight-icon.svg";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { getBooking } from "../../../redux/slices/bookingSlice";
import {
    getCurrencyBadge,
    getFlightsParams,
    postPunchOutAndOpenExternal,
    getThreeFilterToShow,
} from "../../../helpers/common";
import {
    getAppConfig,
    setActivityIndicator,
} from "../../../redux/slices/appconfigSlice";
import PriceFlipper from "../../PriceFlipper";
import PriceBlurWrapper from "../../PriceBlurWrapper";
import { getSearchFilters } from "../../../redux/slices/searchFilterSlice";
import { getLoginConfig } from "../../../redux/slices/loginconfigSlice";
import { GetFlightDetailsService } from "../../../services/HotelDetailServices";
import { toast } from "react-toastify";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import CatImage from "../../../assets/images/genius-footer-logo.svg";
import useTranslationCustom from "../../../i18n/customHook/useTranslation";
import PropTypes from "prop-types";
import { getDetailUrl } from "../../../utils/detailUrl";

const DeatilsCard = ({ steps, setSteps, roomsFetched, flightsFetched }) => {
    const { T } = useTranslationCustom();
    const dispatch = useDispatch();
    const booking = useSelector(getBooking);
    const { room, flight } = booking;
    const searchfilters = useSelector(getSearchFilters);
    const loginConfig = useSelector(getLoginConfig);
    const appConfig = useSelector(getAppConfig);

    // The canonical detail URL, not window.location: the address bar is swapped
    // for the share URL once the package details API resolves.
    const url = getDetailUrl();
    const isFav = (typeof window !== 'undefined' ? new URL(url).searchParams.get("fav") : null) === 'true';
    const isChatOffer = new URL(url).searchParams.get("chatOffer") === 'true';

    const getPrice = (price) => Number(price?.value).toFixed(0) || 0;
    const [price, setPrice] = useState(
        getPrice(flight?.price?.packageTotalPrice)
    );
    const [oldPrice, setOldPrice] = useState(
        getPrice(flight?.price?.packageTotalPrice)
    );

    useEffect(() => {
        setOldPrice(price);
        setPrice(getPrice(flight?.price?.packageTotalPrice));
    }, [flight]);

    const isLoaded = roomsFetched && flightsFetched;

    let filters = getThreeFilterToShow(room, T, flight);

    const handleOnBooking = () => {
        setSteps(prevSteps => prevSteps.map(m => {
            return { ...m, completed: true }
        }));
        const params = getFlightsParams(
            room,
            searchfilters,
            loginConfig,
            booking,
            appConfig,
            searchfilters?.selectedHotel?.id,
            searchfilters?.selectedHotel?.guidForBooking,
            isFav,
            isChatOffer
        );
        const BaseUrl = window.location.origin;
        const newTab = window.open(`${BaseUrl}/fetching`, '_blank');

        try {
            params.GetFinalExpediaUrl = true;
            params.transaction_id = appConfig?.transaction_id;

            // console.log(JSON.stringify(params), "params for getting more flights");

            dispatch(setActivityIndicator(true));
            GetFlightDetailsService(params)
                .then((_flightDetails) => {
                    dispatch(setActivityIndicator(false));

                    // console.log({_flightDetails});

                    if (
                        _flightDetails?.warnings?.length &&
                        _flightDetails?.warnings[0]?.code === "400.19"
                    ) {
                        toast.info(_flightDetails?.warnings[0]?.description);
                        if (newTab) {
                            newTab.close();
                        }
                        return;
                    }

                    const externalUrl = _flightDetails?.offers[0]?.links?.webDetails?.href;
                    postPunchOutAndOpenExternal({
                        url: externalUrl,
                        transactionId: appConfig?.transaction_id,
                        guid: searchfilters?.selectedHotel?.guidForBooking,
                        dispatch,
                        setActivityIndicator,
                        existingTab: newTab,
                    });
                })
                .catch(() => {
                    dispatch(setActivityIndicator(false));
                    if (newTab) {
                        newTab.close();
                    }
                });
        } catch (e) {
            if (newTab) {
                newTab.close();
            }
        }
    };

    function calculatePercentage() {
        if (steps[2]?.completed) {
            return 100;
        } else if (steps[1]?.completed) {
            return 50;
        } else if (steps[0]?.completed) {
            return 0;
        } else return 0;
    }

    return (
        <>
            <div className="desktop-price-section">
                <div className="container">
                    <div className="bluebox-bg">
                        <div className="price-info-holder">
                            <div className="price">
                                {Number(flight?.price?.savings?.value) > 0 && (
                                    <div className="total desktop">
                                        {T("Packages_Detail:Total")}{" "}
                                        <PriceBlurWrapper isLoading={!isLoaded} size="xs">
                                            <em>
                                                {`${getCurrencyBadge(
                                                    flight?.price?.standAloneTotalPrice?.currency
                                                )} ${Number(
                                                    flight?.price?.standAloneTotalPrice?.value
                                                ).toFixed(0)}`}
                                            </em>
                                        </PriceBlurWrapper>
                                    </div>
                                )}
                                <div className="flipper_box d-flex align-items-center gap-2">
                                    <span className="currency-icon">
                                        {getCurrencyBadge(flight?.price?.packageTotalPrice?.currency)}
                                    </span>

                                    <PriceBlurWrapper isLoading={!isLoaded} size="md">
                                        <PriceFlipper price={price} oldPrice={oldPrice} />
                                    </PriceBlurWrapper>
                                </div>

                                <div className="floater-total-taxes">
                                    {flight?.price?.hotelMandatoryFees && (
                                        <div className="text-white">
                                            <PriceBlurWrapper isLoading={!isLoaded} showSpinner={false}>
                                                <span>
                                                    <strong>
                                                        {`+${getCurrencyBadge(
                                                            flight?.price?.hotelMandatoryFees?.currency
                                                        )}${Number(
                                                            flight?.price?.hotelMandatoryFees?.value
                                                        ).toFixed(2)}`}
                                                    </strong>
                                                </span>
                                            </PriceBlurWrapper>
                                            {" "}
                                            <span className="local-taxes desktop">
                                                {T("Packages_Detail:Local_Taxes_Text")}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="tags-total">
                                <div className="text-center">
                                    {filters?.map((f, i) => (
                                        <div key={i} className="badge">
                                            {f?.title}
                                        </div>
                                    ))}
                                </div>
                                <div className="steps-box">
                                    <ProgressBar
                                        percent={calculatePercentage()}
                                        height={3}
                                        filledBackground="linear-gradient(to right, #007bff, #007bff)"
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {steps?.map((step, index) => (
                                            <Step key={index} index={index} transition="scale">
                                                {() => (
                                                    <div className={"step"}>
                                                        <div
                                                            className={`circle ${step?.completed ? "active" : ""
                                                                }`}
                                                        >
                                                            <img
                                                                className={"step-icon"}
                                                                src={step?.icon}
                                                                alt={"step-icon"}
                                                            />
                                                        </div>
                                                        <p className={"step-label"}>{step?.name}</p>
                                                    </div>
                                                )}
                                            </Step>
                                        ))}
                                    </ProgressBar>
                                </div>
                            </div>

                            <div className="action">
                                <div>
                                    <img className="genius-icon" src={CatImage} alt="genius-icon" />
                                </div>
                                <a onClick={handleOnBooking}>
                                    {T("Packages_Detail:Want_This_Deal")}
                                </a>
                                <div className="average-price">
                                    {T("Packages_Detail:Average_Price")}
                                    <div className="d-flex">
                                        <div className="currency">
                                            {getCurrencyBadge(
                                                flight?.price?.averageCostPerPerson?.currency
                                            )}
                                        </div>
                                        <PriceBlurWrapper isLoading={!isLoaded} size="sm">
                                            <div className="amount">
                                                {Number(
                                                    flight?.price?.averageCostPerPerson?.value
                                                ).toFixed(2)}
                                            </div>
                                        </PriceBlurWrapper>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mobiles-price-section">
                <div className="container">
                    <div className="bluebox-bg">
                        <div className="tags-total">
                            <div>
                                <div>
                                    {filters?.map((f, i) => (
                                        <div key={i} className="badge">
                                            {f?.title}
                                        </div>
                                    ))}
                                </div>
                                {Number(flight?.price?.savings?.value) > 0 && (
                                    <div className="total mobile">
                                        {T("Packages_Detail:Total")}{" "}
                                        <PriceBlurWrapper isLoading={!isLoaded} showSpinner={false}>
                                            <em>
                                                {`${getCurrencyBadge(
                                                    flight?.price?.standAloneTotalPrice?.currency
                                                )} ${Number(
                                                    flight?.price?.standAloneTotalPrice?.value
                                                ).toFixed(0)}`}
                                            </em>
                                        </PriceBlurWrapper>
                                    </div>
                                )}
                            </div>
                            <div className="average-price">
                                {T("Packages_Detail:Average_Price")}
                                <div className="d-flex">
                                    <div className="currency">
                                        {getCurrencyBadge(
                                            flight?.price?.averageCostPerPerson?.currency
                                        )}
                                    </div>
                                    <PriceBlurWrapper isLoading={!isLoaded} size="sm">
                                        <div className="amount">
                                            {Number(flight?.price?.averageCostPerPerson?.value).toFixed(0)}
                                        </div>
                                    </PriceBlurWrapper>
                                </div>
                            </div>
                        </div>
                        <div className="price-info-holder">
                            <div className="price">
                                <div className="flipper_box d-flex align-items-center gap-2">
                                    {getCurrencyBadge(flight?.price?.packageTotalPrice?.currency)}

                                    <PriceBlurWrapper isLoading={!isLoaded}>
                                        <PriceFlipper price={price} oldPrice={oldPrice} />
                                    </PriceBlurWrapper>
                                </div>

                                <div className="floater-total-taxes">
                                    {Number(flight?.price?.savings?.value) > 0 && (
                                        <div className="total desktop">
                                            {T("Packages_Detail:Total")}{" "}
                                            <PriceBlurWrapper isLoading={!isLoaded}>
                                                <em>
                                                    {`${getCurrencyBadge(
                                                        flight?.price?.standAloneTotalPrice?.currency
                                                    )} ${Number(
                                                        flight?.price?.standAloneTotalPrice?.value
                                                    ).toFixed(0)}`}
                                                </em>
                                            </PriceBlurWrapper>
                                        </div>
                                    )}

                                    {flight?.price?.hotelMandatoryFees && (
                                        <div className="text-white">
                                            <PriceBlurWrapper isLoading={!isLoaded} showSpinner={false}>
                                                <span>
                                                    <strong>
                                                        {`+${getCurrencyBadge(
                                                            flight?.price?.hotelMandatoryFees?.currency
                                                        )} ${Number(
                                                            flight?.price?.hotelMandatoryFees?.value
                                                        ).toFixed(2)}`}
                                                    </strong>
                                                </span>
                                            </PriceBlurWrapper>
                                            {" "}
                                            <span className="local-taxes desktop">
                                                {T("Packages_Detail:Local_Taxes_Text")}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="action">
                                <a onClick={handleOnBooking}>
                                    {T("Packages_Detail:Want_This_Deal")}
                                    <img
                                        src={BedFlightIcon}
                                        className="bed-icon"
                                        alt={"bed-icon"}
                                    />
                                </a>
                            </div>
                        </div>
                        {flight?.price?.hotelMandatoryFees && (
                            <div className="local-taxes forSmaller">{T("Packages_Detail:Local_Taxes_Text")}</div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
};

DeatilsCard.propTypes = {
    steps: PropTypes.any,
    setSteps: PropTypes.func,
    roomsFetched: PropTypes.bool,
    flightsFetched: PropTypes.bool,
}

export default React.memo(DeatilsCard);
